/**
 * CitationLink Component
 *
 * Renders numbered citation badges as clickable links
 * Following Mantine design system patterns
 */

import React from 'react';
import { Badge, Anchor } from '@mantine/core';
import classes from './CitationLink.module.css';
import type { CitationLinkProps } from '../types';

export const CitationLink: React.FC<CitationLinkProps> = ({
  index,
  citation,
  onClick
}) => {
  return (
    <Anchor
      href={citation.url || '#'}
      target={citation.url ? '_blank' : undefined}
      rel={citation.url ? 'noopener noreferrer' : undefined}
      className={classes.citationLink}
      onClick={(e) => {
        // Always prevent native anchor navigation — the parent
        // handler (AssistantMessage) owns URL opening via safelyOpenUrl
        // to avoid multiple tabs being opened simultaneously.
        e.preventDefault();
        onClick(citation);
      }}
      title={citation.url ? `${citation.text} - ${citation.url}` : citation.text}
      underline="never"
      style={{ cursor: 'pointer' }}
    >
      <Badge component="span" size="xs" variant="filled" className={classes.citationBadge}>
        {index}
      </Badge>
    </Anchor>
  );
};
